// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const blue = "RadialProgressbar__blue__ueJ60";
export const bold = "700";
export const filling = "RadialProgressbar__filling__aBE2t";
export const green = "RadialProgressbar__green__Ck-nl";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const progressbar = "RadialProgressbar__progressbar__9JsRL";
export const regular = "400";
export const sans = "'sans'";
export const scale = "RadialProgressbar__scale__FoxMe";
export const semibold = "600";
export const serif = "'serif'";